import script from "./changeCity.vue?vue&type=script&setup=true&lang=js"
export * from "./changeCity.vue?vue&type=script&setup=true&lang=js"

import "./changeCity.vue?vue&type=style&index=0&id=47ce5dcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ce5dcc"]])

export default __exports__